import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "text-xs text-gray-400" }

import { computed, PropType } from "vue";

import { IAcsEvent } from "@/types/acs-events";
import { formatDate } from "@/utils";

import UiIcon from "@/components/ui/UiIcon.vue";
import UiCell from "@/plugins/ui/components/cell/UiCell.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AcsEventCell',
  props: {
  event: { type: Object as PropType<IAcsEvent>, required: true },
},
  setup(__props) {

const props = __props



const time = computed(() =>
  formatDate(props.event.date, { timeStyle: "short" })
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UiCell, null, {
    left: _withCtx(() => [
      (__props.event.type === 'in')
        ? (_openBlock(), _createBlock(UiIcon, {
            key: 0,
            icon: "ArrowSmRight",
            class: "text-green-500"
          }))
        : (__props.event.type === 'out')
          ? (_openBlock(), _createBlock(UiIcon, {
              key: 1,
              icon: "ArrowSmLeft",
              class: "text-purple-500"
            }))
          : (__props.event.type === 'reject')
            ? (_openBlock(), _createBlock(UiIcon, {
                key: 2,
                icon: "X",
                class: "text-red-500"
              }))
            : (_openBlock(), _createBlock(UiIcon, {
                key: 3,
                icon: "MinusSm"
              }))
    ]),
    default: _withCtx(() => [
      _createElementVNode("p", null, _toDisplayString(__props.event.description), 1),
      _createElementVNode("p", _hoisted_1, _toDisplayString(_unref(time)), 1)
    ]),
    _: 1
  }))
}
}

})